module.exports = __webpack_public_path__ + "static/lbg-46687456c3385bb57e556ab606ed942c.png";